import React, { forwardRef } from 'react';
import { DSIconElement } from '@saucelabs/ds-icons';
import { AriaButtonProps, useButton, useFocusVisible } from 'react-aria';
import classnames from 'classnames';
import { useObjectRef } from '@react-aria/utils';
import { Tooltip } from '@saucelabs/ds-tooltip';

export const ChangeIndicatorButton = forwardRef<
  HTMLButtonElement, ChangeIndicatorButtonProps
>((props, forwardedRef) => {
  const { icon: Icon, className, ...other } = props;
  const { isDisabled } = other;
  const ref = useObjectRef(forwardedRef);
  const { buttonProps, isPressed } = useButton(other, ref);
  const { isFocusVisible } = useFocusVisible();

  return (
    <Tooltip
      placement="top"
      title={props['aria-label']}
    >
      <button
        ref={ref}
        className={classnames(className,
          'border-none appearance-none p-1 cursor-pointer  outline-none',
          'bg-gray-50', {
            'focus:ring focus:ring-blue-100 focus:z-10 focus:relative': isFocusVisible,
            'bg-gray-300': isPressed,
            'text-disabled': isDisabled,
            'text-gray-600 hover:bg-gray-200 active:bg-gray-300': !isDisabled,
          })}
        type="button"
        {...buttonProps}
      >
        <Icon className="w-2 h-2 block fill-current" />
      </button>
    </Tooltip>
  );
});

export interface ChangeIndicatorButtonProps extends AriaButtonProps {
  icon: DSIconElement;
  className?: string;
}
